/**
 * Small brand chip (logo or initial + name) shown on Brand Portfolio notification rows.
 */

import { useState } from 'react';

interface NotificationBrandChipProps {
  name: string;
  logo?: string | null;
}

/** The server already restricts logos to our media hosts; here only https is accepted (no javascript:, data:, http:). */
const isHttpsUrl = (value: string): boolean => {
  try {
    return new URL(value).protocol === 'https:';
  } catch {
    return false;
  }
};

export const NotificationBrandChip = ({ name, logo }: NotificationBrandChipProps) => {
  const [logoFailed, setLogoFailed] = useState(false);
  const initial = name.trim().charAt(0).toUpperCase() || '?';

  return (
    <span className="inline-flex max-w-full items-center gap-1.5 rounded-full bg-gray-100 py-0.5 pl-0.5 pr-2 text-xs text-gray-700">
      {logo && isHttpsUrl(logo) && !logoFailed ? (
        <img
          src={logo}
          alt=""
          className="h-4 w-4 flex-shrink-0 rounded-full object-cover"
          onError={() => setLogoFailed(true)}
        />
      ) : (
        <span
          aria-hidden="true"
          className="flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full bg-primary-100 text-[9px] font-semibold text-primary-700"
        >
          {initial}
        </span>
      )}
      <span className="truncate">{name}</span>
    </span>
  );
};

export default NotificationBrandChip;
